import { Typography } from "@mui/material";
import { SystemSettingType } from "Infrastructure/Api/Api";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { StyledFlex } from "Components/Shared/StyledComponents";
import { useGetSystemSettingQuery } from "Api/Queries/System/useGetSystemSettingQuery";
import { useSaveSystemSettingMutation } from "Api/Mutations/System/useSaveSystemSettingMutation";
import type React from "react";

type Props = { type: SystemSettingType };

const boolTypes: SystemSettingType[] = [
  SystemSettingType.SendinblueEmails,
  SystemSettingType.LeadRewardForBoth,
];

export const SystemSettingController: React.FunctionComponent<
  React.PropsWithChildren<Props>
> = ({ type }) => {
  const { data: systemSetting } = useGetSystemSettingQuery(type);
  const { mutate: saveSetting, isPending: isSaving } =
    useSaveSystemSettingMutation();

  const isBoolType = boolTypes.includes(type);
  const isActive = systemSetting?.value.toLowerCase() === "true";

  if (!systemSetting || !isBoolType) {
    return null;
  }

  return (
    <div>
      <StyledFlex gap="3px">
        <Typography fontWeight={600}>{systemSetting.type} </Typography>
        <Typography>je </Typography>
        <Typography color={isActive ? "green" : "red"}>
          {isActive ? "aktivní" : "neaktivní"}
        </Typography>
      </StyledFlex>

      <PrimaryButton
        fullWidth={true}
        disabled={isSaving}
        onClick={() => {
          saveSetting({
            value: isActive ? "False" : "True",
            type,
          });
        }}
      >
        {isActive ? "Deaktivovat" : "Aktivovat"}
      </PrimaryButton>
    </div>
  );
};
